import { css, StyleDeclarationValue } from 'aphrodite';
import * as React from 'react';
import { CompanySearchRequestProperty } from '../../../../../extViewmodels';
import { AssigneeIcon } from '../../../../components/svgs/icons/AssigneeIcon';
import { SearchIcon } from '../../../../components/svgs/icons/SearchIcon';
import { TagIcon } from '../../../../components/svgs/icons/TagIcon';
import { Button } from '../../../../components-v2/Button';
import { brandPrimary, header } from '../../../../styles/colors';
import { baseStyleSheet } from '../../../../styles/styles';
import { useCompaniesPageUrlState } from '..';
import {
	CompaniesTab,
	DefaultCompaniesSort,
	getCompanyCriteriaFromTab,
	getCompanyTabFromCriteria,
	useCompaniesSearch,
} from '../CompaniesContext';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	styles?: StyleDeclarationValue[];
}

export const CompaniesSearchBarTypeTabs: React.FC<IProps> = props => {
	const { className, styles } = props;
	const { setSort } = useCompaniesSearch();
	const [
		{ companySearchProperty, companySearchValue, companyOrTags, companyAndTags, companyNotTags },
		setCompanyFilterSearch,
	] = useCompaniesPageUrlState();

	const onTabClick = (newTab: CompaniesTab) => () => {
		setCompanyFilterSearch({ companySearchProperty: getCompanyCriteriaFromTab(newTab) });
	};

	const onClear = () => {
		setCompanyFilterSearch({
			companySearchProperty: CompanySearchRequestProperty.Name,
			companySearchValue: '',
			companyOrTags: [],
			companyAndTags: [],
			companyNotTags: [],
		});
		setSort(DefaultCompaniesSort);
	};

	const hasTextSearch = companySearchValue !== '';
	const hasTagFilters = companyOrTags.length > 0 || companyAndTags.length > 0 || companyNotTags.length > 0;
	const hasSearched = hasTextSearch || hasTagFilters;

	const tab = getCompanyTabFromCriteria(companySearchProperty);

	return (
		<div className={`${css(styleSheet.container, ...(styles || []))} ${className || ''}`}>
			<div className={css(styleSheet.tabContainer, !hasTextSearch && baseStyleSheet.hidden)}>
				<FakeTab onClick={onTabClick} tab='All' selectedTab={tab}>
					<SearchIcon className={css(styleSheet.tabIcon)} fillColor={tab === 'All' ? brandPrimary : header} />
				</FakeTab>
				<FakeTab onClick={onTabClick} tab='Name' selectedTab={tab}>
					<AssigneeIcon
						className={css(styleSheet.tabIcon)}
						style={{ color: tab === 'Name' ? brandPrimary : header }}
						strokeWidth='1.5'
					/>
				</FakeTab>
				<FakeTab onClick={onTabClick} tab='Tag' selectedTab={tab}>
					<TagIcon className={css(styleSheet.tabIcon)} fillColor={tab === 'Tag' ? brandPrimary : header} />
				</FakeTab>
			</div>
			{hasSearched && (
				<Button variant='secondary' onClick={onClear}>
					Clear search
				</Button>
			)}
		</div>
	);
};

interface ITabProps {
	onClick(newTab: CompaniesTab): () => void;
	tab: CompaniesTab;
	selectedTab: CompaniesTab;
}

const FakeTab: React.FC<React.PropsWithChildren<ITabProps>> = ({ onClick, children, tab, selectedTab }) => {
	return (
		<div className={css(styleSheet.tab, tab === selectedTab && styleSheet.tabSelected)} onClick={onClick(tab)}>
			{children}
			<span className={css(styleSheet.tabText, tab === selectedTab && styleSheet.tabTextSelected)}>{tab}</span>
		</div>
	);
};
